export default "__VITE_ASSET__xByS$mzD__"